"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseCard = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _transitions = _interopRequireDefault(require("polished/lib/shorthands/transitions"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lightBackground';
  var elevation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing,
      boxShadow = _useTheme.boxShadow,
      radius = _useTheme.heights.radius;

  return {
    root: _objectSpread({
      backgroundColor: colors[color],
      borderRadius: spacing(radius),
      minHeight: spacing(12),
      minWidth: spacing(12),
      boxShadow: boxShadow('shadow', elevation)
    }, (0, _transitions.default)('box-shadow', '150ms ease-in-out'))
  };
};

__signature__(useStyles, "useTheme{{\n    colors,\n    spacing,\n    boxShadow,\n    heights: { radius },\n  }}", function () {
  return [_useTheme2.default];
});

function Card(props, ref) {
  var color = props.color,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["color", "elevation"]);
  var classes = useStyles(color, elevation);
  return (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    ref: ref,
    css: classes.root
  }, other));
}

__signature__(Card, "useStyles{classes}", function () {
  return [useStyles];
});

var BaseCard = (0, _react.forwardRef)(Card);
exports.BaseCard = BaseCard;

var _default = (0, _react.forwardRef)(Card);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Card/index.tsx");
  reactHotLoader.register(Card, "Card", "/builds/bA1zbJom/0/gojob/ui-bits/src/Card/index.tsx");
  reactHotLoader.register(BaseCard, "BaseCard", "/builds/bA1zbJom/0/gojob/ui-bits/src/Card/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Card/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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